<template>

    <div class="food-tags" 
         :class="{ 'food-tags-flex-column' : food_tag_shown === true}" 
         v-lazy-container="{ selector: 'img' }" 
         @click.stop="food_tag_shown = !food_tag_shown"
         role="img"
         :aria-label="getAllergensLabel">

        <div v-for="food_tag in foodTags" 
             :key="food_tag" 
             class="food-tag" 
             :class="{ 'food-tag-bottom-margin' : food_tag_shown === true }"
             aria-hidden="true">
            <img :data-src="require(`../assets/tag_icons/${food_tag}.svg`)"
                 :alt="getFoodTagName(food_tag)" />
            <!-- <transition name="fade"> -->
              <div class="food-tag-name" 
                   v-if="food_tag_shown === true" 
                   :style="{ fontFamily: foodTagNameFontFamily, fontSize: foodTagNameFontSize }">
                {{ getFoodTagName(food_tag)}}
              </div>
            <!-- </transition> -->
        </div>

    </div>



</template>

<script>

export default {
    name: 'FoodTags',
    props: ['food', 'foodTagNameFontFamily', 'foodTagNameFontSize'],
    data () {
      return {
        food_tag_shown: false
      }
    },
    methods: {
      getIcon(food_tag) {
          return 
      },
      getFoodTagName(foodTag) {
        let foodTagName = ""
        if (foodTag === "spicy_level_one") {
          foodTagName = "Spicy"
        } else if (foodTag === "spicy_level_two") {
          foodTagName = "Very spicy"
        } else if (foodTag === "spicy_level_three") {
          foodTagName = "Extremely spicy"
        } else if (foodTag === "sustainable_fishing") {
          foodTagName = "Sustainable fishing"
        } else if (foodTag === "alcohol") {
          foodTagName = "Contains Alcohol"
        } else if (foodTag === "dairy_free") {
          foodTagName = "Dairy-Free"
        } else if (foodTag === "twenty_four_hours") {
          foodTagName = "Available 24 Hours"
        } else if (foodTag === "chef_recommended") {
          foodTagName = "Chef Recommended"
        } else if (foodTag === "sesame_seeds") {
          foodTagName = "Sesame"
        } else if (foodTag === "alcohol_free") {
          foodTagName = "Non-Alcoholic"
        } else if (foodTag === "gluten_free") {
          foodTagName = "Gluten-Free"
        } else if (foodTag === "soy_beans") {
          foodTagName = "Soy"
        } else if (foodTag === "walnuts") {
          foodTagName = "Tree Nuts"          
        } else {
          foodTagName = foodTag
        }
        return foodTagName
      }
    },
    computed: {
      foodTags() {
        let foodTags = []
        if (this.food.spicy == true) {
          foodTags.push('spicy')
        }
        if (this.food.spicy_level_two == true) {
          foodTags.push('spicy_level_two')
        }
        if (this.food.spicy_level_three == true) {
          foodTags.push('spicy_level_three')
        }
        if (this.food.chef_recommended == true) {
          foodTags.push('chef_recommended')
        }
        if (this.food.pork == true) {
          foodTags.push('pork')
        }
        if (this.food.vegetarian == true) {
          foodTags.push('vegetarian')
        }
        if (this.food.halal == true) {
          foodTags.push('halal')
        }
        if (this.food.dairy == true) {
          foodTags.push('dairy')
        }
        if (this.food.fish == true) {
          foodTags.push('fish')
        }
        if (this.food.alcohol == true) {
          foodTags.push('alcohol')
        }
        if (this.food.alcohol_free == true) {
          foodTags.push('alcohol_free')
        }
        if (this.food.gluten == true) {
          foodTags.push('gluten')
        }
        if (this.food.gluten_free == true) {
          foodTags.push('gluten_free')
        }
        if (this.food.peanuts == true) {
          foodTags.push('peanuts')
        }
        if (this.food.shellfish == true) {
          foodTags.push('shellfish')
        }
        if (this.food.egg == true) {
          foodTags.push('egg')
        }
        if (this.food.twenty_four_hours == true) {
          foodTags.push('twenty_four_hours')
        }
        if (this.food.soy_beans == true) {
          foodTags.push('soy_beans')
        }
        if (this.food.walnuts == true) {
          foodTags.push('walnuts')
        }
        if (this.food.celery == true) {
          foodTags.push('celery')
        }
        if (this.food.mustard == true) {
          foodTags.push('mustard')
        }
        if (this.food.sesame_seeds == true) {
          foodTags.push('sesame_seeds')
        }
        if (this.food.sulfites == true) {
          foodTags.push('sulfites')
        }
        if (this.food.lupin == true) {
          foodTags.push('lupin')
        }
        if (this.food.clams == true) {
          foodTags.push('clams')
        }
        if (this.food.sustainable_fishing == true) {
          foodTags.push('sustainable_fishing')
        }
        if (this.food.dairy_free == true) {
          foodTags.push('dairy_free')
        }
        if (this.food.vegan== true) {
          foodTags.push('vegan')
        }
        return foodTags
      },
      getAllergensLabel() {
        // Create a comprehensive label for screen readers
        if (this.foodTags.length === 0) {
          return 'No allergen or dietary information'
        }
        
        const allergens = []
        const dietary = []
        const special = []
        
        // Categorize tags for better screen reader announcement
        this.foodTags.forEach(tag => {
          const name = this.getFoodTagName(tag)
          
          // Allergens
          if (['peanuts', 'shellfish', 'egg', 'soy', 'tree nuts', 'celery', 'mustard', 'sesame', 'sulfites', 'lupin', 'clams', 'dairy', 'fish', 'gluten'].includes(name.toLowerCase()) || 
              tag.includes('dairy') || tag.includes('gluten') || tag.includes('peanuts') || 
              tag.includes('shellfish') || tag.includes('egg') || tag.includes('soy') || 
              tag.includes('walnuts') || tag.includes('celery') || tag.includes('mustard') || 
              tag.includes('sesame') || tag.includes('sulfites') || tag.includes('lupin') || 
              tag.includes('clams') || tag.includes('fish')) {
            allergens.push(name)
          }
          // Dietary preferences/restrictions
          else if (['vegetarian', 'vegan', 'halal', 'gluten-free', 'dairy-free', 'non-alcoholic'].includes(name.toLowerCase()) || 
                   tag.includes('vegetarian') || tag.includes('vegan') || tag.includes('halal') || 
                   tag.includes('free')) {
            dietary.push(name)
          }
          // Special tags
          else {
            special.push(name)
          }
        })
        
        let label = 'Dietary and allergen information: '
        const parts = []
        
        if (allergens.length > 0) {
          parts.push('Contains ' + allergens.join(', '))
        }
        if (dietary.length > 0) {
          parts.push(dietary.join(', '))
        }
        if (special.length > 0) {
          parts.push(special.join(', '))
        }
        
        return label + parts.join('. ') + '.'
      }
    }
}

</script>

<style scoped>

.food-tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 6px 0px 0px 0px;
}

.food-tags-flex-column {
  flex-direction: column !important;
  /* margin-top: 15px; */
}

.food-tag {
    box-sizing: border-box;
    padding: 0px 10px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.food-tag img {
    width: 15px;
    height: 15px;
}

.food-tag-name {
    font-size: 12px;
    font-weight: 400;
    transition: 0.2s;
    margin: 0px 0px 0px 10px;
    text-transform: capitalize;
    animation: fadeIn 0.5s ease-in;
}

.food-tag-bottom-margin {
  margin-bottom: 6px;
}

.food-tag-bottom-margin:last-child {
  margin-bottom: 0px;
}


@keyframes fadeIn {
    0% {opacity: 0;}
    100% { opacity: 1;}
}



</style>